/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Charts_Legend_MissedInputs */

const en_us2_ui_charts_legend_missed = /** @type {(inputs: Ui_Charts_Legend_MissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missed`)
};

const pt_br2_ui_charts_legend_missed = /** @type {(inputs: Ui_Charts_Legend_MissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perdido`)
};

const es_419_ui_charts_legend_missed = /** @type {(inputs: Ui_Charts_Legend_MissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perdido`)
};

const pt_pt2_ui_charts_legend_missed = /** @type {(inputs: Ui_Charts_Legend_MissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falhado`)
};

const fr_fr2_ui_charts_legend_missed = /** @type {(inputs: Ui_Charts_Legend_MissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manqué`)
};

const de_de2_ui_charts_legend_missed = /** @type {(inputs: Ui_Charts_Legend_MissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verpasst`)
};

const it_it2_ui_charts_legend_missed = /** @type {(inputs: Ui_Charts_Legend_MissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saltato`)
};

/**
* | output |
* | --- |
* | "Missed" |
*
* @param {Ui_Charts_Legend_MissedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const ui_charts_legend_missed = /** @type {((inputs?: Ui_Charts_Legend_MissedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Charts_Legend_MissedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_ui_charts_legend_missed(inputs)
	if (locale === "es-419") return es_419_ui_charts_legend_missed(inputs)
	if (locale === "pt-PT") return pt_pt2_ui_charts_legend_missed(inputs)
	if (locale === "fr-FR") return fr_fr2_ui_charts_legend_missed(inputs)
	if (locale === "de-DE") return de_de2_ui_charts_legend_missed(inputs)
	if (locale === "it-IT") return it_it2_ui_charts_legend_missed(inputs)
	return en_us2_ui_charts_legend_missed(inputs)
});
export { ui_charts_legend_missed as "ui-charts.legend_missed" }